
document.addEventListener('DOMContentLoaded', function () {
  const configurator = document.querySelector('#purpur-product-configurator');
  const dataElement = document.querySelector('#purpur-configurator-product-data');

  if (!configurator || !dataElement) return;

  let data;

  try {
    data = JSON.parse(dataElement.textContent);
  } catch (error) {
    console.error('PURPUR Configurator: invalid product data', error);
    return;
  }

  const checkboxes = configurator.querySelectorAll(
    'input[type="checkbox"][data-option]'
  );

  const totalElement = configurator.querySelector(
    '[data-configurator-total]'
  );

  const ADDON_PRODUCT_HANDLE = 'aa-test-storage-box';

  let addonVariantMapPromise = null;
  let addonProcessing = false;
  let allowOriginalClick = false;

  function normalize(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ');
  }

  function normalizeMatch(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/×/g, 'X')
      .replace(/[^A-Z0-9]/g, '');
  }

  /*
   * PURPUR:
   * ELECTRIC LIFT and ELECTRIC LIFT.
   * are two different options.
   *
   * Preserve the final dot in the matching key.
   */
  function normalizeOptionMatch(value) {
    const name = normalize(value);
    const key = normalizeMatch(name);

    if (name.endsWith('.')) {
      return key + '__DOT';
    }

    return key;
  }

  /*
   * Storage options are mutually exclusive.
   *
   * STORAGE BOX
   * ELECTRIC LIFT
   * ELECTRIC LIFT.
   *
   * Only one can be selected at a time.
   */
  function isStorageChoice(value) {
    const key = normalizeOptionMatch(value);

    return (
      key === 'STORAGEBOX' ||
      key === 'ELECTRICLIFT' ||
      key === 'ELECTRICLIFT__DOT'
    );
  }

  function getCheckboxOptionName(checkbox) {
    const key = checkbox.dataset.option;
    const option = parsedOptions[key];

    return option
      ? option.name || key
      : key;
  }

  function enforceStorageExclusion(selectedCheckbox) {
    if (!selectedCheckbox.checked) return;

    const selectedName =
      getCheckboxOptionName(selectedCheckbox);

    if (!isStorageChoice(selectedName)) return;

    checkboxes.forEach(function (otherCheckbox) {
      if (otherCheckbox === selectedCheckbox) return;

      const otherName =
        getCheckboxOptionName(otherCheckbox);

      if (isStorageChoice(otherName)) {
        otherCheckbox.checked = false;

        const row = otherCheckbox.closest(
          '.purpur-configurator__option'
        );

        if (row) {
          row.classList.remove('is-selected');
        }
      }
    });
  }

  function ensureSingleStorageChoice() {
    let selectedStorage = null;

    checkboxes.forEach(function (checkbox) {
      if (!checkbox.checked) return;

      const name = getCheckboxOptionName(checkbox);

      if (!isStorageChoice(name)) return;

      if (!selectedStorage) {
        selectedStorage = checkbox;
        return;
      }

      checkbox.checked = false;

      const row = checkbox.closest(
        '.purpur-configurator__option'
      );

      if (row) {
        row.classList.remove('is-selected');
      }
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('lv-LV', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function getCurrentVariant() {
    const variantId = getVariantIdFromUrl();

    if (variantId) {
      const match = data.variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (match) return match;
    }

    const idInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"]'
    );

    if (idInput && idInput.value) {
      const match = data.variants.find(function (variant) {
        return String(variant.id) === String(idInput.value);
      });

      if (match) return match;
    }

    return data.variants[0] || null;
  }

  const parsedOptions = {};

  (data.options || []).forEach(function (option) {
    if (!option || !option.key) return;

    parsedOptions[option.key] = {
      name: option.name || '',
      enabled: option.enabled === true
    };
  });

  function getCartLabel(optionName) {
    return 'BED ' + normalize(optionName);
  }

  /*
   * BED OPTIONS variant naming:
   *
   * FIXED PRICE:
   * HIGH LEGS
   *
   * SIZE PRICE:
   * STORAGE BOX | 120X200
   *
   * SIZE + FABRIC GROUP PRICE:
   * HIGH HEADBOARD | 120X200 | GROUP 1
   *
   * ELECTRIC LIFT and ELECTRIC LIFT.
   * have separate matching keys.
   *
   * No number of sizes or fabric groups is hard-coded.
   */
  async function getAddonVariantMap() {
    if (addonVariantMapPromise) {
      return addonVariantMapPromise;
    }

    const root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    addonVariantMapPromise = fetch(
      root + 'products/' + ADDON_PRODUCT_HANDLE + '.js',
      {
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Could not load PURPUR BED OPTIONS product'
          );
        }

        return response.json();
      })
      .then(function (product) {
        const map = {};

        (product.variants || []).forEach(function (variant) {
          const variantTitle =
            variant.public_title ||
            variant.option1 ||
            variant.title ||
            '';

          const parts = String(variantTitle)
            .split('|')
            .map(function (part) {
              return part.trim();
            })
            .filter(Boolean);

          if (!parts.length) return;

          const optionKey =
            normalizeOptionMatch(parts[0]);

          if (!optionKey) return;

          if (!map[optionKey]) {
            map[optionKey] = {
              base: null,
              sizes: {},
              groups: {},
              hasSizeSpecific: false,
              hasGroupSpecific: false
            };
          }

          const record = {
            id: Number(variant.id),
            title: variantTitle,
            price: Number(variant.price),
            available: variant.available,
            image: variant.featured_image || null
          };

          /*
           * OPTION
           */
          if (parts.length === 1) {
            map[optionKey].base = record;
            return;
          }

          const sizeKey = normalizeMatch(parts[1]);

          /*
           * OPTION | SIZE
           */
          if (parts.length === 2) {
            map[optionKey].hasSizeSpecific = true;
            map[optionKey].sizes[sizeKey] = record;
            return;
          }

          /*
           * OPTION | SIZE | GROUP
           */
          const fabricKey = normalizeMatch(parts[2]);

          map[optionKey].hasGroupSpecific = true;

          if (!map[optionKey].groups[sizeKey]) {
            map[optionKey].groups[sizeKey] = {};
          }

          map[optionKey].groups[sizeKey][fabricKey] = record;
        });

        return map;
      });

    return addonVariantMapPromise;
  }

  /*
   * Matching priority:
   *
   * GROUP-specific variants:
   * OPTION | SIZE | GROUP
   *
   * SIZE-specific variants:
   * OPTION | SIZE
   *
   * Otherwise:
   * OPTION
   *
   * Missing variants hide the option.
   */
  function resolveAddonVariant(
    addonMap,
    optionName,
    productVariant
  ) {
    if (!productVariant) return null;

    const optionKey =
      normalizeOptionMatch(optionName);

    const bucket = addonMap[optionKey];

    if (!bucket) return null;

    const sizeKey =
      normalizeMatch(productVariant.size);

    const fabricKey =
      normalizeMatch(productVariant.fabric);

    if (bucket.hasGroupSpecific) {
      if (
        bucket.groups[sizeKey] &&
        bucket.groups[sizeKey][fabricKey]
      ) {
        return bucket.groups[sizeKey][fabricKey];
      }

      return null;
    }

    if (bucket.hasSizeSpecific) {
      if (bucket.sizes[sizeKey]) {
        return bucket.sizes[sizeKey];
      }

      return null;
    }

    return bucket.base || null;
  }

  function updateMainProductPrice(cents) {
    const selectors = [
      '[data-product-price]',
      '.product__price',
      '.product-single__price',
      '.product__price--current',
      '.product-price',
      '.price-item--regular'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.closest('#purpur-product-configurator')) return;

        element.textContent = formatMoney(cents);
      });
    });
  }

  async function updateConfigurator() {
    const variant = getCurrentVariant();

    if (!variant) return;

    let addonMap;

    try {
      addonMap = await getAddonVariantMap();
    } catch (error) {
      console.error(
        'PURPUR Configurator: could not load BED OPTIONS',
        error
      );
      return;
    }

    /*
     * Safety check:
     * Never count two storage choices together.
     */
    ensureSingleStorageChoice();

    let optionsTotal = 0;

    checkboxes.forEach(function (checkbox) {
      const optionKey = checkbox.dataset.option;
      const option = parsedOptions[optionKey];

      const row = checkbox.closest(
        '.purpur-configurator__option'
      );

      if (!option || !option.enabled) {
        if (row) row.style.display = 'none';

        checkbox.checked = false;
        checkbox.disabled = true;
        return;
      }

      const optionName = option.name || optionKey;

      const addonVariant = resolveAddonVariant(
        addonMap,
        optionName,
        variant
      );

      /*
       * No valid variant for current SIZE / GROUP.
       * Hide the option completely.
       */
      if (!addonVariant || !addonVariant.available) {
        checkbox.checked = false;
        checkbox.disabled = true;

        if (row) {
          row.style.display = 'none';
          row.classList.remove('is-selected');
        }

        return;
      }

      checkbox.disabled = false;

      if (row) {
        row.style.display = '';
        row.classList.toggle(
          'is-selected',
          checkbox.checked
        );
      }

      const priceElement = configurator.querySelector(
        '[data-option-price="' + optionKey + '"]'
      );

      if (priceElement) {
        priceElement.textContent =
          addonVariant.price > 0
            ? '+' + formatMoney(addonVariant.price)
            : '';
      }

      if (checkbox.checked) {
        optionsTotal += Number(addonVariant.price) || 0;
      }
    });

    const configuredTotal =
      Number(variant.price || 0) + optionsTotal;

    if (totalElement) {
      totalElement.textContent =
        formatMoney(configuredTotal);
    }

    updateMainProductPrice(configuredTotal);
  }

  async function getSelectedAddons() {
    const variant = getCurrentVariant();

    if (!variant) return [];

    const addonMap =
      await getAddonVariantMap();

    /*
     * Prevent incompatible storage options
     * from being added to the cart.
     */
    ensureSingleStorageChoice();

    const addons = [];

    checkboxes.forEach(function (checkbox) {
      if (!checkbox.checked || checkbox.disabled) return;

      const optionKey = checkbox.dataset.option;
      const option = parsedOptions[optionKey];

      if (!option || !option.enabled) return;

      const optionName =
        option.name || optionKey;

      const addonVariant = resolveAddonVariant(
        addonMap,
        optionName,
        variant
      );

      if (!addonVariant) {
        throw new Error(
          'No BED OPTIONS variant exists for "' +
            optionName +
            '" / ' +
            String(variant.size || '') +
            ' / ' +
            String(variant.fabric || '')
        );
      }

      if (!addonVariant.available) {
        throw new Error(
          'BED OPTIONS variant is unavailable: "' +
            addonVariant.title +
            '"'
        );
      }

      addons.push({
        key: optionKey,
        name: optionName,
        cartLabel: getCartLabel(optionName),
        variantId: addonVariant.id,
        price: addonVariant.price
      });
    });

    return addons;
  }

  function buildAddonCartItems(
    addons,
    quantity,
    parentVariantId
  ) {
    return addons.map(function (addon) {
      return {
        id: addon.variantId,
        quantity: quantity,

        properties: {
          '_PURPUR addon': '1',

          '_PURPUR cart label':
            addon.cartLabel,

          '_PURPUR_CART_LABEL':
            addon.cartLabel,

          '_PURPUR option':
            addon.name,

          '_PURPUR parent variant':
            String(parentVariantId)
        }
      };
    });
  }

  async function addAddonItems(items) {
    if (!items.length) return;

    const root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    const response = await fetch(
      root + 'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },

        body: JSON.stringify({
          items: items
        })
      }
    );

    if (!response.ok) {
      const errorText =
        await response.text();

      throw new Error(errorText);
    }

    return response.json();
  }

  /*
   * PURPUR STORAGE EXCLUSION:
   *
   * Selecting STORAGE BOX removes:
   * ELECTRIC LIFT
   * ELECTRIC LIFT.
   *
   * Selecting either ELECTRIC LIFT
   * removes STORAGE BOX and the other lift.
   *
   * All other options remain independent.
   */
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener(
      'change',
      function () {
        enforceStorageExclusion(checkbox);
        updateConfigurator();
      }
    );
  });

  document.addEventListener(
    'click',

    async function (event) {
      const button = event.target.closest(
        'form[action*="/cart/add"] button[type="submit"], ' +
          'form[action*="/cart/add"] input[type="submit"], ' +
          'form[action*="/cart/add"] [name="add"]'
      );

      if (!button) return;

      const form = button.closest(
        'form[action*="/cart/add"]'
      );

      if (!form) return;

      if (allowOriginalClick) {
        allowOriginalClick = false;
        return;
      }

      const hasSelectedAddon =
        Array.from(checkboxes).some(function (checkbox) {
          return checkbox.checked && !checkbox.disabled;
        });

      /*
       * No Bed Options selected:
       * let Impulse work normally.
       */
      if (!hasSelectedAddon) {
        return;
      }

      /*
       * Stop Impulse immediately while we add
       * the Bed Option variants first.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      if (addonProcessing) return;

      addonProcessing = true;

      const variant = getCurrentVariant();

      if (!variant) {
        addonProcessing = false;

        console.error(
          'PURPUR Configurator: current product variant not found'
        );

        return;
      }

      const quantityInput =
        form.querySelector('[name="quantity"]');

      const quantity =
        quantityInput
          ? Math.max(
              1,
              Number(quantityInput.value) || 1
            )
          : 1;

      try {
        const addons =
          await getSelectedAddons();

        const items =
          buildAddonCartItems(
            addons,
            quantity,
            variant.id
          );

        await addAddonItems(items);

        allowOriginalClick = true;
        addonProcessing = false;

        button.click();
      } catch (error) {
        addonProcessing = false;

        console.error(
          'PURPUR Configurator: add-on cart error',
          error
        );

        alert(
          'Configuration could not be added to cart. Please try again.'
        );
      }
    },

    true
  );

  document.addEventListener(
    'click',

    function () {
      setTimeout(updateConfigurator, 50);
      setTimeout(updateConfigurator, 200);
      setTimeout(updateConfigurator, 500);
    },

    true
  );

  document.addEventListener(
    'change',

    function () {
      setTimeout(updateConfigurator, 50);
      setTimeout(updateConfigurator, 200);
      setTimeout(updateConfigurator, 500);
    },

    true
  );

  let lastVariantId =
    getVariantIdFromUrl();

  setInterval(function () {
    const currentVariantId =
      getVariantIdFromUrl();

    if (
      currentVariantId !==
      lastVariantId
    ) {
      lastVariantId =
        currentVariantId;

      updateConfigurator();
    }
  }, 250);

  updateConfigurator();
});
